@if ($loading) {
  <div class="flex animate-pulse items-center gap-2">
    @for (file of files(); track file.activityFileId) {
      <div class="rounded-lg bg-slate-100" [ngClass]="sizeClass()"></div>
    }
  </div>
} @else {
  @if (hasFiles) {
    <div class="flex flex-wrap gap-2">
      @for (file of files(); track file.activityFileId) {
        <div
          class="relative flex flex-col rounded-md border border-slate-200 bg-slate-100 duration-200"
          [ngClass]="getStylesClass">
          @if (showDeleteButton()) {
            <button
              type="button"
              class="!absolute right-1 top-1 flex h-6 w-6 items-center justify-center rounded-full bg-warn-80 !text-white hover:brightness-90"
              (click)="onDeleteFile(file)"
              matTooltip="Eliminar">
              <mat-icon class="qaroni-mat-icon-20" fontIcon="close" />
            </button>
          }

          @if (isImageFile(file.file)) {
            <a
              class="h-full"
              role="button"
              tabindex="0"
              (click)="onFileVisualization(file)"
              (keydown.enter)="onFileVisualization(file)"
              (keydown.space)="onFileVisualization(file)"
              [class.cursor-pointer]="enableVisualization()">
              <img
                [src]="file.fileUrl"
                [alt]="file.file"
                class="h-full rounded-lg object-cover object-center"
                [matTooltip]="file.file" />
            </a>
          } @else {
            <div
              class="flex size-full flex-col items-center justify-center gap-1 px-4"
              [matTooltip]="file.file"
              role="button"
              tabindex="0"
              (click)="onFileVisualization(file)"
              (keydown.enter)="onFileVisualization(file)"
              (keydown.space)="onFileVisualization(file)"
              [class.cursor-pointer]="enableVisualization()">
              <mat-icon
                fontIcon="description"
                class="qaroni-mat-icon-48"
                color="accent" />
              <span class="text-xs font-light text-slate-500">
                {{ file.file | fileNameTruncate: 7 }}
              </span>
            </div>
          }
        </div>
      }
    </div>
  }
}
